import { IComparator, IEntity, NameValue } from '@infodata-group/inf-commons';

export class VAT implements IEntity, IComparator {
  serialize() {
    throw new Error('Method not implemented.');
  }
  public code: string;
  public environment: NameValue = new NameValue('', '');
  public label: string;
  public operationType: string;
  public prctCompta: number;
  public prctDeclaration: number;
  public prctNoDed: any;
  public lock: boolean;
  public showOnlyCode = true;

  convert(item: any): VAT {
    if (item) {
      const vat = new VAT();
      if (item instanceof VAT) {
        vat.code = item.code;
        vat.environment = item.environment;
        vat.label = item.label;
        vat.operationType = item.operationType;
        vat.prctCompta = item.prctCompta;
        vat.prctDeclaration = item.prctDeclaration;
        vat.prctNoDed = item.prctNoDed;
      } else {
        vat.code = item.Code;
        vat.environment.name = item.Environement?.Id;
        vat.environment.value = item.Environement?.Label;
        vat.label = item.Label;
        vat.operationType = item.OperationType;
        vat.prctCompta = item.PrctCompta;
        vat.prctDeclaration = item.PrctDeclaration;
        vat.prctNoDed = item.PrctNoDed;
      }
      return vat;
    }
  }

  toString() {
    if (this.showOnlyCode) {
      return this.code;
    } else {
      return `(${this.code}) ${this.label}`;
    }
  }

  getId(): string {
    return this.code;
  }

  getLabel(): string {
    return this.label;
  }

  compare(comparant: any): number {
    if (typeof comparant === 'string') {
      return this.code.localeCompare(comparant);
    } else {
      return this.code.localeCompare(comparant.code);
    }
  }
}
